import ResponsiveTable from '../ReusableComponents/ResponsiveTable';
import React, { useState, useEffect } from 'react';
import OperationPanel from './components/OperationPanel';
import ApplicationFilters from './components/ApplicationFilters';
import { can } from '../../permissions';
import { Link, useLocation, useHistory } from 'react-router-dom';
import DefaultButton from '../ReusableComponents/DefaultButton';
import { MdRemoveRedEye, MdPlaylistAddCheck, MdClear } from 'react-icons/md';
import { usePortal, useInscricoes, useSelecoes } from './hooks';
import PortalLayout from './components/PortalLayout';
import { Loading, ErrorNotice, Empty, Status } from './components/Feedback';
import Pagination from './components/Pagination';
import ExportStatus from './components/ExportStatus';
export default function PortalApplications() {
  const [selected, setSelected] = useState([]);
  const { base, user, labels } = usePortal(),
    location = useLocation(),
    history = useHistory(),
    params = new URLSearchParams(location.search),
    selections = useSelecoes(),
    external = params.get('ontest_faculdade_id'),
    mapped = selections.data?.find((s) => String(s.ontest_faculdade_id) === external)?.id,
    scoped = !external || !!mapped,
    filters = {
      busca: params.get('busca') || '',
      status: params.get('status') || '',
      selection_id: params.get('selection_id') || mapped || '',
      integration_status: params.get('integration_status') || '',
      ...Object.fromEntries(
        [
          'position_id',
          'name',
          'cpf',
          'email',
          'number',
          'from',
          'to',
          'sort',
          'document_status',
        ].map((k) => [k, params.get(k) || ''])
      ),
      page: Number(params.get('page') || 1),
    },
    query = useInscricoes(filters, scoped);
  const filterKey = JSON.stringify(Object.entries(filters).filter(([key]) => key !== 'page'));
  useEffect(() => {
    setSelected([]);
  }, [filterKey]);
  return (
    <PortalLayout
      title="Inscrições do portal"
      description="Analise inscrições, documentos, recursos e pendências de vinculação."
    >
      <section className="card module-card module-content portal-received-applications">
        <div className="card-body portal-applications-content">
          <div className="portal-admin-row">
            <div className="module-content-heading">
              <h2>Inscrições recebidas</h2>
              <p>Pesquise os candidatos e abra uma inscrição para consultar os detalhes.</p>
            </div>
            <div className="portal-admin-actions portal-list-actions hidethis">
              {scoped &&
                (can(user, 'portal_inscricoes', 'edit') ||
                  can(user, 'portal_integracoes', 'edit')) && (
                  <OperationPanel filters={filters} selected={selected} />
                )}
              {scoped && can(user, 'portal_relatorios', 'view') && (
                <ExportStatus filters={filters} />
              )}
            </div>
          </div>
          {external && !mapped && !selections.isLoading && (
            <div className="alert alert-warning">
              Sincronize este seletivo no módulo de publicações para consultar suas inscrições.
            </div>
          )}
          <ApplicationFilters
            key={location.search + filters.selection_id}
            filters={filters}
            selections={selections.data}
            onFilter={(data) => {
              setSelected([]);
              history.push({
                pathname: location.pathname,
                search: new URLSearchParams(Object.entries(data).filter(([, v]) => v)).toString(),
              });
            }}
          />
          {!!selected.length && (
            <div className="portal-selection-count hidethis" role="status">
              <div className="portal-selection-summary">
                <span className="portal-selection-icon" aria-hidden="true"><MdPlaylistAddCheck /></span>
                <div>
                  <strong>{selected.length} {selected.length === 1 ? 'inscrição selecionada' : 'inscrições selecionadas'}</strong>
                  <span>Use Ações em lote para gerenciar esta seleção.</span>
                </div>
              </div>
              <DefaultButton text="Limpar seleção" bg="secondary" icon={<MdClear />} onClick={() => setSelected([])} />
            </div>
          )}
          <ErrorNotice error={query.error || selections.error} />
          {query.isLoading || selections.isLoading ? (
            <Loading />
          ) : query.data?.data?.length ? (
            <div className="portal-applications-results">
              <ResponsiveTable className="table table-striped">
                <thead>
                  <tr>
                    <th className="hidethis">Selecionar</th>
                    <th>Candidato</th>
                    <th>
                      {labels.selection} / {labels.position}
                    </th>
                    <th>Inscrição</th>
                    <th>Situação</th>
                    <th>Recebida em</th>
                    <th>Documentos</th>
                    <th>Vinculação</th>
                    <th className="hidethis">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {query.data.data.map((app) => (
                    <tr key={app.id}>
                      <td className="hidethis">
                        <input
                          type="checkbox"
                          aria-label={'Selecionar ' + app.user.name}
                          checked={selected.includes(app.id)}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setSelected((ids) =>
                              checked ? [...ids, app.id] : ids.filter((id) => id !== app.id)
                            );
                          }}
                        />
                      </td>
                      <td>
                        <strong>{app.user.name}</strong>
                        <small className="d-block">{app.user.cpf}</small>
                        <small className="d-block">{app.user.email}</small>
                      </td>
                      <td>
                        {app.selection.title}
                        <small className="d-block">{app.position.title}</small>
                      </td>
                      <td>{app.registration_number || app.protocol || 'Rascunho'}</td>
                      <td>
                        <Status value={app.status} />
                      </td>
                      <td>
                        {app.submitted_at
                          ? new Date(app.submitted_at).toLocaleString('pt-BR')
                          : '—'}
                      </td>
                      <td>
                        <Status value={app.document_status} />
                      </td>
                      <td>
                        <Status value={app.integration_status} />
                      </td>
                      <td className="hidethis">
                        <Link
                          className="bg-warning icon portal-action-link hidethis"
                          title="Ver inscrição"
                          to={base + '/inscricoes/' + app.id}
                          aria-label="Ver inscrição"
                        >
                          <MdRemoveRedEye />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </ResponsiveTable>
              <Pagination
                meta={query.data.meta}
                onPage={(page) => {
                  params.set('page', page);
                  history.push({
                    pathname: location.pathname,
                    search: params.toString(),
                  });
                }}
              />
            </div>
          ) : (
            <Empty>Nenhuma inscrição encontrada.</Empty>
          )}
        </div>
      </section>
    </PortalLayout>
  );
}
